import { InstallInstruction } from 'features/install/ui/InstallInstruction';

export const InstallInstructionPage = (): JSX.Element => {
    return (
        <>
            <InstallInstruction></InstallInstruction>
        </>
    );
}
